if (!customElements.get('discount-notification')) {
  customElements.define(
    'discount-notification',
    class DiscountNotification extends HTMLElement {
      connectedCallback() {
        this.closeButton.addEventListener('click', this.handleClose.bind(this))
        this.triggerButton.addEventListener('click', this.handleOpen.bind(this))

        if (!this.repeatNotification && !!localStorage.getItem('notification-closed')) return;

        this.setAttribute('open', '')

        setTimeout(() => {
          this.handleClose()
        }, 5000)
      }

      handleOpen () {
        this.setAttribute('open', true)
      }

      handleClose() {
        this.removeAttribute('open')
        localStorage.setItem('notification-closed', true)
      }

      get repeatNotification () {
        return this.dataset.repeat === 'true'
      }

      get closeButton () {
        return this.querySelector('.js-close')
      }

      get triggerButton () {
        return this.querySelector('.js-notification-trigger')
      }
    })
}
